import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Pages
import Home from '@/pages/Home';
import Lounge from '@/pages/Lounge';
import MeetTheTeam from '@/pages/MeetTheTeam';
import Press from '@/pages/Press';
import Privacy from '@/pages/Privacy';
import Terms from '@/pages/Terms';
import Apply from '@/pages/Apply';
import Testimonials from '@/pages/Testimonials';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/lounge" element={<Lounge />} />
        <Route path="/meet-the-team" element={<MeetTheTeam />} />
        <Route path="/press" element={<Press />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/testimonials" element={<Testimonials />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
